module.exports = "<nvd3 options=\"$ctrl.chartOptions\" data=\"$ctrl.chartData\"></nvd3>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/main/front/scripts/module/statistics/component/gmao-chart.html
// module id = 17
// module chunks = 1